import { SignatureRow } from 'components/tables/data/signature/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({ data: { organization } }: { data: SignatureRow }) {
  return <P2Medium color="gray.8">{organization.organizationName}</P2Medium>;
}
